import { render, staticRenderFns } from "./AddPriorityNumber.vue?vue&type=template&id=40c4492c&scoped=true"
import script from "./AddPriorityNumber.vue?vue&type=script&lang=js"
export * from "./AddPriorityNumber.vue?vue&type=script&lang=js"
import style0 from "./AddPriorityNumber.vue?vue&type=style&index=0&id=40c4492c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4492c",
  null
  
)

export default component.exports